// extracted by mini-css-extract-plugin
export default {"colorLightSleep":"#c1dddc","colorRemSleep":"#6db3b0","colorDeepSleep":"#1a5761","colorAwake":"#e5a212"};